import type { IFilterData } from '@rankmi/rankmi-table/dist/interfaces/filterProps'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import { sortTableEnum } from 'enum/sortTable.enum'
import api from '../..'
import { buildQuery } from './utils'

export interface GetListResponse {
  data: ExternalCourseModelAPI[]
  total: number
  perPage: number
}

export interface ExternalCoursesListSort {
  field?: string
  order?: sortTableEnum
}

export interface ExternalCoursesListParams {
  page?: number
  searchText?: string
  sort?: ExternalCoursesListSort
  usersFilter?: IFilterData
  perPage?: number
  fastFilters?: number
}

const externalCoursesList = (params?: ExternalCoursesListParams) => {
  const { page = 1, perPage = 50 } = {
    ...params,
  }

  const q = buildQuery(params)

  return api
    .post(`administration/external_courses/search`, { page, perPage, q })
    .then<GetListResponse>(({ data, headers }) => {
      return {
        data: data.data.map(({ attributes }: any) => attributes),
        total: parseInt(headers['total']),
        perPage: parseInt(headers['per-page']),
      }
    })
}

export default externalCoursesList
